import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings/settings.component';
import { ReactiveFormsModule } from "@angular/forms";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ButtonComponent } from "app/shared/button/button.component";


@NgModule({
  declarations: [SettingsComponent],
    imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    ButtonComponent
]
})
export class SettingModule { }
